import { centerAligned } from '@medly-components/utils';
import { rgba } from 'polished';
import styled from 'styled-components';

export const MantaHeaderStyled = styled('header')`
    position: sticky;
    top: 0;
    z-index: 1;
    min-height: 6.4rem;
    padding: 0 2.4rem;
    background-color: ${({ theme }) => theme.colors.white};
    box-shadow: 0 0.2rem 0.8rem ${({ theme }) => rgba(theme.colors.grey[500], 0.2)};
    ${centerAligned('flex')};

    @media (min-width: ${({ theme }) => theme.breakpoints.L.min}px) {
        height: 7.2rem;
        padding: 0 9.6rem;
    }
`;
